import { Grid, Typography } from "@mui/material";
import { styled as styling } from "@mui/material/styles";

export const GridContainerStyled = styling(Grid)((props) => ({
  display: "flex",
  padding: "80px 120px",
  flexDirection: "column",
  alignItems: "center",
  gap: "40px",
  background: "#FFF",

  [props.theme.breakpoints.down("lg")]: {
    padding: "40px 24px",
    gap: "48px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    padding: "40px 16px",
    gap: "24px",
    alignItems: "flex-start",
  },
}));

export const CardListContainer = styling(Grid)((props) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "24px",
  width: "calc(100% / 3)",
  padding: "30px",

  [props.theme.breakpoints.down("lg")]: {
    width: "calc(100% / 3)",
  },

  [props.theme.breakpoints.down("tablet")]: {
    width: "100%",
    gap: "16px",
    maxWidth: "unset",
  },
}));

export const TaglineTitle = styling(Typography)((props) => ({
  color: "#261754",
  fontSize: "40px",
  fontWeight: "400",
  fontStyle: "normal",
  lineHeight: "48px",
  fontFamily: "Georgia",
  letterSpacing: "0.06px",
  width: "100%",
  maxWidth: "1200px",

  i: {
    fontStyle: "italic",
  },

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: "24px",
    lineHeight: "28.8px",
    letterSpacing: "0.036px",
  },
}));

export const CardContainer = styling(Grid)((props) => ({
  display: "flex",
  maxWidth: "1200px",
  alignItems: "stretch",
  // gap: "56px 40px",
  flexDirection: "row",
  flexWrap: "nowrap",
  justifyContent: "center",
  background: "rgb(250, 249, 246)",
  border: "1px solid #000",

  [props.theme.breakpoints.down("lg")]: {
    // gap: "40px 24px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    flexDirection: "column",
    // gap: "40px",
  },
}));

export const CardImage = styling("img")((props) => ({
  height: "100%",
  width: "100%",
  flexShrink: "0",
  borderRadius: "8px",
  maxHeight: "64px",
  maxWidth: "64px",
  objectFit: "cover",

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {},
}));

export const CardTextContainer = styling(Grid)((props) => ({
  display: "flex",
  alignItems: "flex-start",
  flexDirection: "column",
  gap: "16px",

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {
    gap: "8px",
    maxWidth: "unset",
  },
}));

export const CardText = styling(Typography)((props) => ({
  color: "#261754",
  fontFamily: props.type == "desc" ? "Inter" : "Inter",
  fontSize: props.type == "desc" ? "16px" : "20px",
  fontStyle: "normal",
  fontWeight: props.type == "desc" ? 400 : 500,
  lineHeight: props.type == "desc" ? "24px" : "25px",
  alignSelf: "stretch",
  letterSpacing: props.type == "desc" ? "0.15px" : "unset",

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: props.type == "desc" ? "14px" : "16px",
    lineHeight: props.type == "desc" ? "21px" : "24px",
    letterSpacing: props.type == "desc" ? "unset" : "unset",
  },
}));

export const LineBreak = styling("div")((props) => ({
  width: "1px",
  backgroundColor: "#000",
  margin: "0",

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {
    width: "100%",
    height: "1px",
  },
}));
